export const data = {
  businessName: "ZeyVentures LLC",
  address: "W356N6752 E. Stonewood Dr, Oconomowoc, WI 53066",
  phone: "505-933-1752",
  email: "zeyventures@gmail.com",
  zeyVenturesUrl: "https://zeyventures.com",
};
